
// Utility functions for price handling

// Format price to Brazilian Real (BRL) currency format
export const formatPrice = (price) => {
    const formatoBRL = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });

    return formatoBRL.format(price);
};
